import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a manual GA4 `page_view` on every SPA route change.
 *
 * Rationale: `gtag('config', 'G-…')` in index.html only fires ONE page_view
 * on initial load. Client-side navigations via React Router don't trigger
 * any hit — so GA reports internal routes (e.g. `/histoire`, `/reservation`)
 * as "not tagged" in the tag-coverage report, even though the tag physically
 * loads on every page.
 *
 * Consent Mode v2 is respected transparently: when `analytics_storage` is
 * `denied`, gtag automatically sends cookieless pings; when `granted`, full
 * event.
 */
export default function AnalyticsTracker() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        if (typeof window === "undefined" || typeof window.gtag !== "function") return;
        // Skip the very first fire on initial page load — `gtag('config', ...)`
        // in index.html already sent one page_view for it.
        if (window.__fol_ga_initial_fired__ !== true) {
            window.__fol_ga_initial_fired__ = true;
            return;
        }
        const page_path = pathname + (search || "");
        window.gtag("event", "page_view", {
            page_path,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [pathname, search]);
    return null;
}
